import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { Popover, Menu } from 'antd';
import fetch from '@/utils/fetch';
import storage from '@/utils/storage';
import styles from './index.module.scss';
import avator from '@/assets/images/icon_me.svg';
import withStore from '@/store/withStore';

const { Item } = Menu;

class AvatarImg extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };
  }
  onClick = async ({ key }) => {
    this.setState({ visible: false });
    if (key !== 'logout') return;
    const data = await fetch('/saasmerchant/logout?platformCode=FS');
    if (data) {
      storage.clear();
      const curUrl = encodeURIComponent(window.location.href);
      const passUrl = data.url.replace('%2FPLACEHOLDER%2F', curUrl);
      window.location.replace(passUrl);
    }
  };
  render() {
    const { visible } = this.state;
    const {
      lessonNoticeList,
      rootPower: { '/school/center': rootPower },
    } = this.props;

    const {
      actionMap: { SCHOOL_CENTER_VIEW },
    } = rootPower || { actionMap: {} };

    return (
      <Popover
        overlayClassName={styles.popover}
        trigger="click"
        placement="bottomLeft"
        arrowPointAtCenter
        visible={visible}
        title={<div style={{ fontSize: '14px', width: '100px' }}>个人中心</div>}
        onVisibleChange={(status) => this.setState({ visible: status })}
        content={
          <Menu onClick={this.onClick}>
            {SCHOOL_CENTER_VIEW && (
              <Item key="school">
                <Link to="/school/center">
                  <div>丰食学堂</div>
                </Link>
              </Item>
            )}
            <Item key="account">
              <Link to="/account">账号设置</Link>
            </Item>
            <Item key="logout">
              <span style={{ color: '#FF5555' }}>退出</span>
            </Item>
          </Menu>
        }
      >
        {/* <Avatar icon="u ser" size={30} className="ant-avatar" /> */}
        <img src={avator} className="ant-avatar" alt="头像" />
      </Popover>
    );
  }
}

export default connect(...withStore('basic'))(AvatarImg);
